import Grille from './grilles.model';

export default class TarifController {
	/* @ngInject */

	constructor(
		$scope,
		$state,
		$stateParams,
		SocietesService,
		TarifsService,
		SocietesTypesService,
		ModalService,
		MOPService,
		notification,
		$translate,
		moment,
		$filter,
		_,
		globalizationManagementService,
		PaginationService,
		$timeout
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.SocietesService = SocietesService;
		this.TarifsService = TarifsService;
		this.SocietesTypesService = SocietesTypesService;
		this.ModalService = ModalService;
		this.MOPService = MOPService;
		this.notification = notification;
		this.$translate = $translate;
		this.moment = moment;
		this.$filter = $filter;
		this._ = _;
		this.PaginationService = PaginationService;
		this.sitesCommerciaux = [];
		this.grilles = [];
		this.tvaListe = [];
		this.showNewGrilleForm = false;
		this.showDuplicateCodeGrilleForm = false;
		this.newGrille = new Grille();
		this.selectedGrille = null;
		this.grilleModele = null;
		this.displayedGrille = null;
		this.formulaireTitre = 'Ajouter une nouvelle grille';
		this.prixTypes = null;
		this.grillesParentes = [];
		this.loading = false;
		this.$timeout = $timeout;

		this.transporteurs = [];
		this.originalGrilleCode = null;
		this.dateSimulationAchat = this.moment().format(this.dateFormat);
		this.dateTest = this.moment().format(this.dateFormat);

		this.dateFormat = globalizationManagementService.getCurrentLanguage().dateFormat;
		this.displayDateMask = globalizationManagementService.getCurrentLanguage().displayDateMask;

		this.itemsByPageOptions = [50, 200, 1000];
		this.itemsByPage = this.itemsByPageOptions[0];
		this.initialVal = {};

		this.testOpen = false;
		this.allGrilles = [];
		this.hasSelectedIncreasePriceType = false;
		this.isAllPrixCocheSelected = false;
		this.isAnyPrixCocheSelected = false;
		this.CocheSelectedElementCount = 0;
		this.grilleRefreshKey = 0;
		this.filtreStatutGranulat = 'actif';
		this._allPrixGranulats = [];
		this.filtreStatutEnrobe = 'actif';
		this._allPrixEnrobes = [];
		this.filtreStatutLiant = 'actif';
		this._allPrixLiants = [];
	}

	async $onInit() {
		this.previousMOP = this.MOPService.getCurrentMOP();
		this.MOPService.setMop([{ title: 'GRILLES.GRILLES_TARIFAIRES', filename: 'GrillesTarifaires.pdf', application: 'gestion' }]);
		await this.getTvaListe();
		await this.getTypesPrix();

		if (this.idGrille) {
			const grille = {
				id: this.idGrille
			};
			this.displayGrille(grille);
		} else {
			this.selectedSens = 'true';
			if (this.domaine !== 'societe' && this.domaine !== 'siteCommercial') {
				this.societes = await this.TarifsService.getSocietes();
				this.selectedSocieteId = this.societes[0].id;
				await this.loadSitesCommerciaux(this.selectedSocieteId);
			}
			await this.getGrilles();

			await this.getTransporteurs();
			this.htmlPopover = '<input type="text" class="form-control" placeholder="Text input">';
			this.initNewGrille();

			const _this = this;
			this.$scope.$watch('$ctrl.newGrille.dateDebut', function () {
				_this.getGrillesParentes();
			});
			this.$scope.$watch('$ctrl.newGrille.dateFin', function () {
				_this.getGrillesParentes();
			});

			this.$scope.$watch('$ctrl.showDuplicateCodeGrilleForm', () => {
				if (this.showDuplicateCodeGrilleForm) {
					this.loadAllGrilles();
				} else {
					this.allGrilles = [];
				}
			});

			this.isTransportOpen = false;
		}

		this.increasePriceType = await this.TarifsService.getIncreasePriceType();

		if (this.resolve?.fromExportGrille && this.source.idSiteCommercial) {
			this.selectedSocieteId = this.source.idSociete;
			this.changeSociete();
			this.selectedSiteCommercialId = this.source.idSiteCommercial;
			this.changeSiteCommercial();
		}
	}

	$onDestroy() {
		this.MOPService.resetMop();
		if (this.previousMOP) this.MOPService.setMop(this.previousMOP, false);
	}

	initNewGrille() {
		this.formulaireTitre = 'Ajouter une nouvelle grille';
		this.newGrille = new Grille();
		this.newGrille.societeId = null;
		this.newGrille.siteCommercialId = null;
		this.newGrille.typeClientId = null;
		this.newGrille.clientId = null;
		this.newGrille.chantierId = null;

		switch (this.domaine) {
			case 'societe':
				this.newGrille.societeId = this.source.id;
				break;
			case 'siteCommercial':
				this.newGrille.siteCommercialId = this.source.id;
				break;
			case 'typeClient':
				this.newGrille.typeClientId = this.source.id;
				break;
			case 'client':
				this.newGrille.clientId = this.source.id;
				break;
			case 'chantier':
			case 'provenance':
				this.newGrille.chantierId = this.source.id;
				break;
		}
	}

	changePrixInitial() {
		if (this.newGrille.isPrixInitial == true) {
			this.newGrille.isPrixAugmente = false;
		}
	}

	changePrixAugmente() {
		if (this.newGrille.isPrixAugmente == true) {
			this.newGrille.isPrixInitial = false;
		}
	}

	ajouterNewGrille() {
		this.showNewGrilleForm = true;
		this.showDuplicateCodeGrilleForm = false;
		this.initNewGrille();
	}

	initDupliquerGrille() {
		this.formulaireTitre = 'Sélectionner une grille existante';
		this.showNewGrilleForm = false;
		this.showDuplicateCodeGrilleForm = true;
	}

	closeAccordeon() {
		this.isGranulatOpen = false;
		this.isEnrobeOpen = false;
		this.isLiantOpen = false;
		this.isPrestationOpen = false;
		this.isTransportOpen = false;
	}

	async loadSitesCommerciaux() {
		this.sitesCommerciaux = await this.TarifsService.getSitesCommerciauxBySociete(this.selectedSocieteId);
	}

	async getGrillesParentes() {
		let urlDomainName = 'societe';
		let urlDomainId = this.selectedSocieteId;
		let filters = {};
		if (this.selectedSens != 'stock') {
			if (this.selectedSiteCommercialId) {
				urlDomainName = 'siteCommercial';
				urlDomainId = this.selectedSiteCommercialId;
			}

			switch (this.domaine) {
				case 'societe':
					urlDomainName = 'societe';
					urlDomainId = this.source.id;
					break;
				case 'siteCommercial':
					urlDomainName = 'siteCommercial';
					urlDomainId = this.source.id;
					break;
				case 'typeClient':
					filters = {
						typeClientId: this.source.id
					};
					break;
				case 'client':
					filters = {
						clientId: this.source.id
					};
					break;
				case 'chantier':
				case 'provenance':
					filters = {
						chantierId: this.source.id
					};
					break;
			}

			filters.achatVente = this.selectedSens;

			if (this.selectedTransporteur != null) {
				filters.transporteurId = this.selectedTransporteur;
			}

			if (urlDomainName == 'societe') {
				filters.societeId = urlDomainId;
			} else {
				filters.siteCommercialId = urlDomainId;
			}

			filters.dateDebut = this.newGrille.dateDebut;
			filters.dateFin = this.newGrille.dateFin;

			this.grillesParentes = await this.TarifsService.getGrillesParentes(filters);
			this.grillesParentes.push({ id: null, libelle: '' });
		}
	}

	async changeSens() {
		this.resetAllPrixcoche();
		this.displayedGrille = null;
		this.grilles = [];
		this.grillesStock = [];
		if (this.selectedSens == 'stock') {
			await this.getGrillesStock();
		} else {
			await this.getGrilles();
		}
	}

	async changeTransporteur() {
		this.displayedGrille = null;
		await this.getGrilles();
	}

	async changeSociete() {
		await this.loadSitesCommerciaux(this.selectedSocieteId);
		this.sitesCommerciaux.unshift({ id: null, libelle: '' });
		this.displayedGrille = null;
		await this.getGrilles();
	}

	async changeSiteCommercial() {
		this.displayedGrille = null;
		await this.getGrilles();
	}

	cancel() {
		this.modalInstance.dismiss();
	}

	async getTransporteurs() {
		try {
			const data = await this.TarifsService.getTransporteurs();
			this.transporteurs = data;
		} catch (err) {
			if (err.data) {
				this.notification.error(err.data);
			} else {
				throw err;
			}
		}
		this.transporteurs.unshift({ id: null, libelle: '' });
	}

	async getGrillesStock() {
		this.loading = true;
		try {
			const urlDomainId = this.source.id;
			const data = await this.TarifsService.getGrillesStock(urlDomainId);
			this.grilles = data;
		} finally {
			this.loading = false;
		}
	}

	async getGrilles() {
		let urlDomainName = 'societe';
		let urlDomainId = this.selectedSocieteId;
		let filters = {};

		if (this.selectedSiteCommercialId) {
			urlDomainName = 'siteCommercial';
			urlDomainId = this.selectedSiteCommercialId;
		}

		switch (this.domaine) {
			case 'societe':
				urlDomainName = 'societe';
				urlDomainId = this.source.id;
				break;
			case 'siteCommercial':
				urlDomainName = 'siteCommercial';
				urlDomainId = this.source.id;
				break;
			case 'typeClient':
				filters = {
					typeClientId: this.source.id
				};
				break;
			case 'client':
				filters = {
					clientId: this.source.id
				};
				break;
			case 'chantier':
			case 'provenance':
				filters = {
					chantierId: this.source.id
				};
				break;
		}
		if (this.resolve?.sourceGrille !== undefined) {
			this.selectedSens = this.resolve.sourceGrille;
		}
		filters.achatVente = this.selectedSens;

		if (this.selectedTransporteur != null) {
			filters.transporteurId = this.selectedTransporteur;
		}

		this.loading = true;
		try {
			if (this.selectedSens == 'stock') {
				this.grilles = await this.TarifsService.getGrillesStock(urlDomainId);
			} else {
				this.grilles = await this.TarifsService.getGrilles(urlDomainName, urlDomainId, filters);
			}

			//Quand on ouvre la modal à partir de l'export de grille, on n'affiche que la grille selectionnée
			if (this.resolve?.fromExportGrille && this.resolve.idGrille) {
				this.grilles = this.grilles.filter((grille) => grille.id == this.resolve.idGrille);
				this.$timeout(() => {
					this.displayGrille(this.grilles[0]);
				});
			}
		} catch (err) {
			if (err.data) {
				this.notification.error(err.data);
			} else {
				throw err;
			}
		} finally {
			this.loading = false;
		}

		if (this.selectedSens != 'stock') {
			this.getGrillesParentes(urlDomainName, urlDomainId, filters);
		}

		this.selectedGrille = null;
	}

	trackFocus(produit) {
		// On stocke le type ET la valeur pour pouvoir comparer avec la valeur finale lors de la perte du focus (blur) et mise à jour de isChanging
		produit.onFocusValeur = produit.valeur;
		produit.onFocusType = produit.type;
	}

	async updatePrix(produit) {
		produit.valueEmpty = this.isValueLineEmpty(produit);

		// return si il n'y a pas de valeur apres Ng-bind
		if (typeof produit.valeur == 'undefined' || produit.valeur == null) {
			return;
		}
		const old = produit.valeur;
		const valeurNumbered = this.convertStringToDecimal(produit.valeur);

		if (produit.valeur == '') {
			produit.valeur = 0;
			if (produit.prixCessionArrondi !== null) {
				produit.prix = produit.prixCessionArrondi;
			}
		}

		let prixDeReference = 0;

		if (produit.prixStandard != null && produit.prixStandard.prix > 0) {
			prixDeReference = produit.prixStandard.prix;
		} else if (produit.prixCessionArrondi != null) {
			prixDeReference = produit.prixCessionArrondi;
		}

		switch (produit.type) {
			case 0: // aucun
				break;
			case 1: // négocié
				produit.prix = valeurNumbered;
				break;
			case 2: // remise %
				produit.prix = prixDeReference - Math.round(((valeurNumbered * prixDeReference) / 100) * 100) / 100;
				break;
			case 3: // remise
				produit.prix = prixDeReference - valeurNumbered;
				break;
			case 4: // marge %
				produit.prix = prixDeReference + Math.round(((valeurNumbered * prixDeReference) / 100) * 100) / 100;
				break;
			case 5: // marge
				produit.prix = prixDeReference + valeurNumbered;
				break;
			default:
				break;
		}
		//Quickfix pour la présentation LME le comportement de la disquette devrait être le même dans la fiche stock
		if (this.selectedSens == 'stock') {
			if (typeof produit !== 'undefined' && produit.savedValeur === produit.valeurNumbered) {
				produit.isChanging = 0;
			} else if (old !== valeurNumbered) {
				produit.isChanging = 1;
			}
		} else {
			if (produit.onFocusValeur !== produit.valeur || produit.onFocusType !== produit.type) {
				produit.isChanging = 1;
			}
		}
		produit.valeur = valeurNumbered;
	}

	closeAddForm() {
		this.showNewGrilleForm = false;
		this.showDuplicateCodeGrilleForm = false;
		this.newGrille = new Grille();
		this.grilleModele = null;
	}

	async loadOrignalGrille(grilleToDuplicate) {
		if (!grilleToDuplicate) {
			this.notification.error('Aucune grille trouvée pour ce code');
		} else {
			this.newGrille.libelle = grilleToDuplicate.libelle;
			this.newGrille.originalGrilleId = grilleToDuplicate.id;
			this.newGrille.formType = 'duplicateByCode';
			this.newGrille.dateDebut = this.$filter('date')(grilleToDuplicate.dateDebut, 'dd/MM/yyyy', 'UTC');
			this.newGrille.dateFin = this.$filter('date')(grilleToDuplicate.dateFin, 'dd/MM/yyyy', 'UTC');
			this.formulaireTitre = 'Duplication de la grille : ' + grilleToDuplicate.libelle;
			this.showNewGrilleForm = true;
			this.showDuplicateCodeGrilleForm = false;
		}
	}

	async addGrille() {
		switch (this.domaine) {
			case 'societe':
				this.newGrille.societeId = this.source.id;
				break;
			case 'siteCommercial':
				this.newGrille.siteCommercialId = this.source.id;
				break;
			case 'typeClient':
				this.newGrille.typeClientId = this.source.id;
				break;
			case 'client':
				this.newGrille.clientId = this.source.id;
				break;
			case 'chantier':
			case 'provenance':
				this.newGrille.chantierId = this.source.id;
				break;
		}
		if (!this.newGrille.libelle) {
			this.notification.error('Le libellé ne peut pas être nul.');
			return;
		}

		if (this.newGrille.dateDebut == null || this.newGrille.dateFin == null) {
			this.notification.error('Les dates ne peuvent pas être nulles.');
			return;
		}

		let isValid = true;
		if (this.UTCDate(this.newGrille.dateDebut).isAfter(this.UTCDate(this.newGrille.dateFin))) {
			isValid = false;
		}
		const newGrilleDebut = this.UTCDate(this.newGrille.dateDebut);
		const newGrilleFin = this.UTCDate(this.newGrille.dateFin);
		angular.forEach(
			this.grilles,
			function (uneGrille) {
				const oldDateDebut = this.UTCDate(uneGrille.dateDebut);
				const oldDateFin = this.UTCDate(uneGrille.dateFin);
				// vérifie que les dates de début et fin de la nouvelle grille ne soient pas inclus dans une grille déjà existante
				if (
					newGrilleDebut.isBetween(oldDateDebut, oldDateFin, 'days', '[]') ||
					newGrilleFin.isBetween(oldDateDebut, oldDateFin, 'days', '[]')
				) {
					isValid = false;
				}
			},
			this
		);

		// verifier si les dates de la grille client sont entre les dates de la grille parente
		if (this.newGrille.clientId != null && this.newGrille.chantierId == null && this.newGrille.grilleParente != null) {
			const grilleParenteIndex = this._.findIndex(this.grillesParentes, {
				id: this.newGrille.grilleParente
			});
			const grilleParente = this.grillesParentes[grilleParenteIndex];

			if (this.UTCDate(this.newGrille.dateDebut).isBefore(this.UTCDate(grilleParente.dateDebut))) {
				isValid = false;
				this.notification.error(
					'La date de début ne peut pas etre avant la date de début de la grille parente : ' +
						this.UTCDate(grilleParente.dateDebut).format('DD/MM/YYYY') +
						'.'
				);
			}

			if (this.UTCDate(this.newGrille.dateFin).isAfter(this.UTCDate(grilleParente.dateFin))) {
				isValid = false;
				this.notification.error(
					'La date de fin ne peut pas etre apres la date de fin de la grille parente : ' +
						this.UTCDate(grilleParente.dateFin).format('DD/MM/YYYY') +
						'.'
				);
			}
		}

		if (isValid) {
			if (this.newGrille.societeId == null || this.newGrille.societeId == undefined) {
				this.newGrille.societeId = this.selectedSocieteId;
			}

			if (this.selectedSiteCommercialId) {
				this.newGrille.siteCommercialId = this.selectedSiteCommercialId;
				this.newGrille.societeId = null;
			}

			this.newGrille.estVente = this.selectedSens;

			if (this.selectedTransporteur != null) {
				this.newGrille.transporteurId = this.selectedTransporteur;
			}

			this.startLoading();

			try {
				if (this.selectedSens == 'stock') {
					await this.TarifsService.createGrilleStock(this.newGrille);
					this.getGrillesStock();
				} else {
					await this.TarifsService.createGrille(this.newGrille);
					this.getGrilles();
				}
			} catch (ex) {
				this.notification.error(ex.data);
				return;
			} finally {
				this.stopLoading();
			}

			this.newGrille = new Grille();

			switch (this.domaine) {
				case 'societe':
					this.newGrille.societeId = this.source.id;
					break;
				case 'siteCommercial':
					this.newGrille.siteCommercialId = this.source.id;
					break;
				case 'typeClient':
					this.newGrille.typeClientId = this.source.id;
					break;
				case 'client':
					this.newGrille.clientId = this.source.id;
					break;
				case 'chantier':
				case 'provenance':
					this.newGrille.chantierId = this.source.id;
					break;
			}

			this.showNewGrilleForm = false;
			this.showDuplicateCodeGrilleForm = false;
			this.grilleModele = null;
		} else {
			this.notification.error('Les dates saisies ne sont pas valides ou rentrent en conflit avec une autre grille.');
		}
	}

	changeIncreasePriceType() {
		this.hasSelectedIncreasePriceType = this.newGrille.increasePriceType.length > 0;
	}

	async displayGrille(grille) {
		console.log('🔥 - TarifController - displayGrille - grille:', grille);
		if (this.selectedGrille != grille) {
			this.loadingGrille = true;
			this.closeAccordeon();
			this.selectedGrille = grille;
			try {
				const [grilleErrors] = await Promise.all([
					this.selectedSens == 'stock' ? Promise.resolve({}) : this.TarifsService.getGrilleErrors(grille.id),
					this.selectedSens == 'stock'
						? this.TarifsService.getGrilleStock(grille.id).then((data) => {
								this.displayedGrille = data;
								angular.forEach(this.displayedGrille.lignes, (x) => {
									x.savedValeur = x.valeur;
									x.savedDensite = x.densite;
									x.savedPourcentagePerte = x.pourcentagePerte;
								});
							})
						: Promise.resolve((this.displayedGrille = []))
				]);
				Object.assign(this.selectedGrille, grilleErrors);
			} finally {
				this.loadingGrille = false;
			}
		}
	}

	async displayGrilleTransport(tableState) {
		try {
			var that = this;
			if (!that.startLoadingTransport) {
				that = this.$parent.$parent.$ctrl;
			}
			let previousTableState;
			that.startLoadingTransport();

			if (tableState) {
				previousTableState = tableState;
			}

			const filters = that.PaginationService.getFilters(previousTableState);
			const sorts = that.PaginationService.getSorts(previousTableState);
			const pagination = that.PaginationService.getPagination(previousTableState);

			const data = await that.TarifsService.getGrilleTransport(that.selectedGrille.id, filters, sorts, pagination);

			that.displayedGrille.prixTransports = data.items;
			if (previousTableState) {
				that.PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
			}
		} catch (ex) {
			that.notification.error(ex.data);
		} finally {
			that.stopLoadingTransport();
			that.resetAllPrixcoche();
		}
	}

	displayGrilleGranulat = async (tableState) => {
		try {
			var that = this;

			if (!that.startLoadingTransport) {
				that = this.$parent.$parent.$ctrl;
			}
			let previousTableState;
			that.startLoadingTransport();

			if (tableState) {
				previousTableState = tableState;
			}

			const filters = that.PaginationService.getFilters(previousTableState);
			const sorts = that.PaginationService.getSorts(previousTableState);
			const pagination = that.PaginationService.getPagination(previousTableState);

			const data = await that.TarifsService.getGrilleGranulat(that.selectedGrille.id, filters, sorts, pagination);

			that._allPrixGranulats = data.items;
			that.applyFiltreGranulat();
			if (previousTableState) {
				that.PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
			}
		} catch (ex) {
			that.notification.error(ex.data);
		} finally {
			that.stopLoadingTransport();
			this.resetAllPrixcoche();
		}
	};

	isSelectedGrilleActive = () => {
		if (!this.selectedGrille) return false;
		const now = new Date();
		const debut = this.selectedGrille.dateDebut ? new Date(this.selectedGrille.dateDebut) : null;
		const fin = this.selectedGrille.dateFin ? new Date(this.selectedGrille.dateFin) : null;
		return debut && fin && debut <= now && fin >= now;
	};

	applyFiltreGranulat = () => {
		if (!this.displayedGrille || !this._allPrixGranulats) return;
		if (this.filtreStatutGranulat === 'actif') {
			this.displayedGrille.prixGranulats = this._allPrixGranulats.filter((p) => p.isProduitProducteurActive);
		} else if (this.filtreStatutGranulat === 'inactif') {
			this.displayedGrille.prixGranulats = this._allPrixGranulats.filter((p) => !p.isProduitProducteurActive);
		} else {
			this.displayedGrille.prixGranulats = [...this._allPrixGranulats];
		}
	};

	displayGrilleEnrobe = async (tableState) => {
		try {
			var that = this;
			if (!that.startLoadingTransport) {
				that = this.$parent.$parent.$ctrl;
			}
			let previousTableState;
			that.startLoadingTransport();

			if (tableState) {
				previousTableState = tableState;
			}

			const filters = that.PaginationService.getFilters(previousTableState);
			const sorts = that.PaginationService.getSorts(previousTableState);
			const pagination = that.PaginationService.getPagination(previousTableState);

			const data = await that.TarifsService.getGrilleEnrobe(that.selectedGrille.id, filters, sorts, pagination);

			that._allPrixEnrobes = data.items;
			that.applyFiltreEnrobe();
			if (previousTableState) {
				that.PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
			}
		} catch (ex) {
			that.notification.error(ex.data);
		} finally {
			that.stopLoadingTransport();
			this.resetAllPrixcoche();
		}
	};

	applyFiltreEnrobe = () => {
		if (!this.displayedGrille || !this._allPrixEnrobes) return;
		if (this.filtreStatutEnrobe === 'actif') {
			this.displayedGrille.prixEnrobes = this._allPrixEnrobes.filter((p) => p.isProduitProducteurActive);
		} else if (this.filtreStatutEnrobe === 'inactif') {
			this.displayedGrille.prixEnrobes = this._allPrixEnrobes.filter((p) => !p.isProduitProducteurActive);
		} else {
			this.displayedGrille.prixEnrobes = [...this._allPrixEnrobes];
		}
	};

	displayGrilleLiant = async (tableState) => {
		try {
			var that = this;
			if (!that.startLoadingTransport) {
				that = this.$parent.$parent.$ctrl;
			}
			let previousTableState;
			that.startLoadingTransport();

			if (tableState) {
				previousTableState = tableState;
			}

			const filters = that.PaginationService.getFilters(previousTableState);
			const sorts = that.PaginationService.getSorts(previousTableState);
			const pagination = that.PaginationService.getPagination(previousTableState);

			const data = await that.TarifsService.getGrilleLiant(that.selectedGrille.id, filters, sorts, pagination);

			that._allPrixLiants = data.items;
			that.applyFiltreLiant();
			if (previousTableState) {
				that.PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
			}
		} catch (ex) {
			that.notification.error(ex.data);
		} finally {
			that.stopLoadingTransport();
			this.resetAllPrixcoche();
		}
	};

	applyFiltreLiant = () => {
		if (!this.displayedGrille || !this._allPrixLiants) return;
		if (this.filtreStatutLiant === 'actif') {
			this.displayedGrille.prixLiants = this._allPrixLiants.filter((p) => p.isProduitProducteurActive);
		} else if (this.filtreStatutLiant === 'inactif') {
			this.displayedGrille.prixLiants = this._allPrixLiants.filter((p) => !p.isProduitProducteurActive);
		} else {
			this.displayedGrille.prixLiants = [...this._allPrixLiants];
		}
	};

	displayGrillePrestation = async (tableState) => {
		try {
			var that = this;
			if (!that.startLoadingTransport) {
				that = this.$parent.$parent.$ctrl;
			}
			let previousTableState;
			that.startLoadingTransport();

			if (tableState) {
				previousTableState = tableState;
			}

			const filters = that.PaginationService.getFilters(previousTableState);
			const sorts = that.PaginationService.getSorts(previousTableState);
			const pagination = that.PaginationService.getPagination(previousTableState);

			const data = await that.TarifsService.getGrillePrestation(that.selectedGrille.id, filters, sorts, pagination);

			that.displayedGrille.prixPrestations = data.items;
			if (previousTableState) {
				that.PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
			}
		} catch (ex) {
			that.notification.error(ex.data);
		} finally {
			that.stopLoadingTransport();
			this.resetAllPrixcoche();
		}
	};

	startLoadingTransport() {
		this.loadingTransport = true;
	}

	stopLoadingTransport() {
		this.loadingTransport = false;
	}

	async changePrixAchat(lignePrix) {
		lignePrix.valueEmpty = this.isValueLineEmpty(lignePrix);

		// return si il n'y a pas de valeur apres Ng-bind
		if (typeof lignePrix.prixAchat == 'undefined' || lignePrix.prixAchat == null) {
			return;
		}
		if (lignePrix.prixAchat == '') {
			lignePrix.prixAchat = null;
		}
		lignePrix.prixAchat = this.convertStringToDecimal(lignePrix.prixAchat);
		lignePrix.prix = this.$filter('number')(lignePrix.prix, 2);

		lignePrix.isChanging = 1;
	}

	async addPrix(produit) {
		if (produit?.valueEmpty) {
			return;
		}

		let result;
		produit.isLoading = 1;
		try {
			if (this.selectedSens == 'stock') {
				/*  if(produit.valeur == undefined || produit.densite == undefined || produit.pourcentagePerte == undefined){
					throw "Mauvaise décimale repérée";
				} */
				produit.savedValeur = produit.valeur;
				produit.savedDensite = produit.densite;
				produit.savedPourcentagePerte = produit.pourcentagePerte;

				produit.grilleStockId = this.selectedGrille.id;
				if (produit.id > 0) {
					result = await this.TarifsService.updateLigneStock(produit);
				} else {
					produit.grilleTarifaireId = this.selectedGrille.id;
					result = await this.TarifsService.createLigneStock(produit);
					produit.id = result.idLigne;
				}
			} else {
				if (produit.id > 0) {
					result = await this.TarifsService.updatePrix(produit);
				} else {
					produit.grilleTarifaireId = this.selectedGrille.id;
					result = await this.TarifsService.createPrix(produit);
					produit.id = result.idPrix;
				}
			}
		} catch (e) {
			console.error(e);
		}

		produit.isChanging = 0;
		produit.isLoading = 0;
		produit.dateModification = result.dateModification;
		if (produit.prix > 0) {
			produit.hasMissingPrix = false;
		}
		this.grilleRefreshKey++;
	}

	async deletePrix(prix) {
		prix.isLoading = 1;
		if (this.selectedSens == 'stock') {
			await this.TarifsService.deleteLigneStock(prix);
			prix.densite = null;
			prix.pourcentagePerte = null;
		} else {
			const ids = [prix.id];
			await this.TarifsService.deletePrix(ids);
			prix.type = 1;
			prix.prixAchat = null;
			prix.transporte = null;
			prix.prix = null;
			prix.isFrozen = false;
		}

		prix.isLoading = 0;
		prix.id = 0;
		prix.valeur = null;
		prix.dateModification = null;
		if (prix.prixStandard === null || prix.prixStandard.prix === null) {
			prix.hasMissingPrix = true;
		}
		this.grilleRefreshKey++;
	}

	async deletePrixProduits() {
		const ids = [];
		angular.forEach(
			this.displayedGrille.prixGranulats,
			function (prix) {
				if (!prix.isEnrobe && prix.type && prix.id) {
					ids.push(prix.id);
					prix.type = 1;
					prix.prixAchat = null;
					prix.transporte = null;
					prix.id = 0;
					prix.valeur = null;
					prix.dateModification = null;
				}
			},
			this
		);
		await this.TarifsService.deletePrix(ids);
	}

	async deletePrixLignes() {
		const ids = [];
		angular.forEach(
			this.displayedGrille.lignes,
			function (prix) {
				if (prix.id) {
					ids.push(prix.id);
					prix.type = 1;
					prix.prixAchat = null;
					prix.transporte = null;
					prix.id = 0;
					prix.valeur = null;
					prix.dateModification = null;
				}
			},
			this
		);
		await this.TarifsService.deletePrix(ids);
	}

	isActualGrille(grille) {
		const now = this.moment.utc();
		const start = this.moment.utc(grille.dateDebut, this.dateFormat);
		const end = this.moment.utc(grille.dateFin, this.dateFormat);

		return now.isBetween(start, end, null, '[)');
	}

	changeGrilleParente() {
		if (this.newGrille.grilleParente != null) {
			const grilleParenteIndex = this._.findIndex(this.grillesParentes, {
				id: this.newGrille.grilleParente
			});
			this.newGrille.dateDebut = this.$filter('date')(this.grillesParentes[grilleParenteIndex].dateDebut, 'dd/MM/yyyy', 'UTC');
			this.newGrille.dateFin = this.$filter('date')(this.grillesParentes[grilleParenteIndex].dateFin, 'dd/MM/yyyy', 'UTC');
		}
	}

	async changeTransporte(lignePrix) {
		lignePrix.isChanging = 1;
	}

	async changeRistourne(lignePrix) {
		lignePrix.valueEmpty = this.isValueLineEmpty(lignePrix);
		lignePrix.ristourne = this.convertStringToDecimal(lignePrix.ristourne);
		lignePrix.isChanging = 1;
	}

	applyMargeGlobale(typeProduit) {
		let selectedPrixListCoche;
		if (typeProduit == 'granulats') {
			selectedPrixListCoche = this.displayedGrille.prixGranulats.filter((prix) => prix.isSelectedCoche);
			angular.forEach(
				selectedPrixListCoche,
				function (ligne) {
					if (this.typeGranulat == 1) {
						ligne.type = this.typeGranulat;
						ligne.valeur = this.margeGlobaleGranulats;
						this.updatePrix(ligne);
					} else {
						if (ligne.prixStandard.prix && this.selectedGrille.grilleParenteId) {
							ligne.type = this.typeGranulat;
							ligne.valeur = this.margeGlobaleGranulats;
							this.updatePrix(ligne);
						}
					}
				},
				this
			);
		} else if (typeProduit == 'enrobes') {
			selectedPrixListCoche = this.displayedGrille.prixEnrobes.filter((prix) => prix.isSelectedCoche);
			angular.forEach(
				selectedPrixListCoche,
				function (ligne) {
					ligne.type = this.typeEnrobe;
					ligne.valeur = this.margeGlobaleEnrobes;
					this.updatePrix(ligne);
				},
				this
			);
		} else if (typeProduit == 'liants') {
			selectedPrixListCoche = this.displayedGrille.prixLiants.filter((prix) => prix.isSelectedCoche);
			angular.forEach(
				selectedPrixListCoche,
				function (ligne) {
					ligne.type = this.typeLiant;
					ligne.valeur = this.margeGlobaleLiants;
					this.updatePrix(ligne);
				},
				this
			);
		} else if (typeProduit == 'prestations') {
			selectedPrixListCoche = this.displayedGrille.prixPrestations.filter((prix) => prix.isSelectedCoche);
			angular.forEach(
				selectedPrixListCoche,
				function (ligne) {
					if (this.typePrestation == 1) {
						ligne.type = this.typePrestation;
						ligne.valeur = this.margeGlobalePrestations;
						this.updatePrix(ligne);
					} else {
						if (ligne.prixStandard.prix && this.selectedGrille.grilleParenteId) {
							ligne.type = this.typePrestation;
							ligne.valeur = this.margeGlobalePrestations;
							this.updatePrix(ligne);
						}
					}
				},
				this
			);
		} else if (typeProduit == 'transports') {
			selectedPrixListCoche = this.displayedGrille.prixTransports.filter((prix) => prix.isSelectedCoche);
			angular.forEach(
				selectedPrixListCoche,
				function (ligne) {
					if (this.typeTransport == 1) {
						ligne.type = this.typeTransport;
						ligne.valeur = this.margeGlobaleTransports;
						this.updatePrix(ligne);
					} else {
						if (ligne.prixStandard.prix && this.selectedGrille.grilleParenteId) {
							ligne.type = this.typeTransport;
							ligne.valeur = this.margeGlobaleTransports;
							this.updatePrix(ligne);
						}
					}
				},
				this
			);
		} else if (typeProduit == 'stock') {
			selectedPrixListCoche = this.displayedGrille.lignes.filter((prix) => prix.isSelectedCoche);
			angular.forEach(
				selectedPrixListCoche,
				function (ligne) {
					ligne.valeur = this.margeGlobaleStock;
					this.updatePrix(ligne);
				},
				this
			);
		}
	}

	updateDensity(ligne) {
		const old = ligne.densite;
		ligne.densite = this.convertStringToDecimal(ligne.densite);
		if (ligne.savedDensite === ligne.densite) {
			ligne.isChanging = 0;
		} else if (old !== ligne.densite) {
			ligne.isChanging = 1;
		}
	}

	updatePercentPerte(ligne) {
		const old = ligne.pourcentagePerte;
		ligne.pourcentagePerte = this.convertStringToDecimal(ligne.pourcentagePerte);
		if (ligne.savedPourcentagePerte === ligne.pourcentagePerte) {
			ligne.isChanging = 0;
		} else if (old !== ligne.pourcentagePerte) {
			ligne.isChanging = 1;
		}
	}

	montreDisquette(ligne) {
		if (ligne.savedValeur == ligne.valeur && ligne.savedDensite == ligne.densite && ligne.savedPourcentagePerte == ligne.pourcentagePerte) {
			ligne.isChanging = 0;
		} else {
			ligne.isChanging = 1;
			ligne.valueEmpty = this.isValueLineEmpty(ligne);
		}
	}

	convertStringToDecimal(value) {
		if (typeof value === 'string') {
			// SL parseFloat() à garder !!
			return parseFloat(value.replace(',', '.').replace(' ', ''));
		}
		return value;
	}

	duplicateGrille(grille) {
		this.formulaireTitre = 'Duplication de la grille : ' + grille.libelle;
		this.showDuplicateCodeGrilleForm = false;
		this.showNewGrilleForm = true;
		this.grilleModele = angular.copy(grille);
		this.newGrille = angular.copy(grille);
		this.newGrille.libelle = this.grilleModele.libelle + ' (copie)';
		this.newGrille.dateFin = this.moment.utc(this.grilleModele.dateFin, 'DD/MM/YYYY');
		this.newGrille.dateDebut = this.moment.utc(this.grilleModele.dateDebut, 'DD/MM/YYYY');
		this.newGrille.formType = 'duplicate';
		this.newGrille.grilleParente = null;
		this.newGrille.originalGrilleId = grille.id;
		this.newGrille.augmenterPrix = false;
		this.newGrille.augmenterPrixProduits = true;
		this.newGrille.augmenterPrixPrestations = false;
		this.newGrille.augmenterPrixTransports = false;
		this.newGrille.pourcentageAugmentation = 0;
		this.newGrille.regleArrondi = '0';
		this.newGrille.increasePriceType = [0];
		this.changeIncreasePriceType();
	}

	editGrille(grille) {
		this.formulaireTitre = 'Edition de la grille : ' + grille.libelle;
		this.showDuplicateCodeGrilleForm = false;
		this.showNewGrilleForm = true;
		this.newGrille = Object.assign({}, grille);
		this.newGrille.formType = 'edit';
		this.newGrille.dateDebut = grille.dateDebut;
		this.newGrille.dateFin = grille.dateFin;
		this.newGrille.grilleParente = grille.grilleParenteId;

		this.getGrillesParentes();
	}

	UTCDate(dateToRead) {
		const formats = ['DD/MM/YYYY', 'YYYY/MM/DD', 'MM/DD/YYYY'];
		for (const format of formats) {
			const parsed = this.moment.utc(dateToRead, format);
			if (parsed.isValid()) {
				return parsed;
			}
		}
		return dateToRead;
	}

	async updateGrille() {
		if (!this.newGrille.libelle) {
			this.notification.error('Le libellé ne peut pas être nul.');
			return;
		}

		if (this.newGrille.dateDebut == null || this.newGrille.dateFin == null || this.newGrille.dateDebut == '' || this.newGrille.dateFin == '') {
			this.notification.error('Les dates ne peuvent pas être nulles.');
			return;
		}

		let isValid = true;
		if (this.UTCDate(this.newGrille.dateDebut).isAfter(this.UTCDate(this.newGrille.dateFin))) {
			isValid = false;
		}

		if (isValid) {
			angular.forEach(
				this.grilles,
				function (uneGrille) {
					if (uneGrille.id != this.newGrille.id) {
						// test si les dates de la nouvelle grille contiennent d'autres grilles
						if (
							this.UTCDate(uneGrille.dateDebut).isSameOrAfter(this.UTCDate(this.newGrille.dateDebut)) &&
							this.UTCDate(uneGrille.dateDebut).isSameOrBefore(this.UTCDate(this.newGrille.dateFin))
						) {
							isValid = false;
						}

						if (
							this.UTCDate(uneGrille.dateFin).isSameOrAfter(this.UTCDate(this.newGrille.dateDebut)) &&
							this.UTCDate(uneGrille.dateFin).isSameOrBefore(this.UTCDate(this.newGrille.dateFin))
						) {
							isValid = false;
						}

						// test si les dates de la nouvelle grille sont comprises dans d'autres grilles
						if (
							this.UTCDate(this.newGrille.dateDebut).isSameOrAfter(this.UTCDate(uneGrille.dateDebut)) &&
							this.UTCDate(this.newGrille.dateFin).isSameOrBefore(this.UTCDate(uneGrille.dateFin))
						) {
							isValid = false;
						}
					}
				},
				this
			);
		}

		if (isValid) {
			try {
				if (this.selectedSens == 'stock') {
					await this.TarifsService.updateGrilleStock(this.newGrille);
				} else {
					await this.TarifsService.updateGrille(this.newGrille);
				}
			} catch (err) {
				if (err.data) {
					this.notification.error(err.data);
				} else {
					throw err;
				}
				return;
			}
		} else {
			this.notification.error('Les dates saisies ne sont pas valides ou rentrent en conflit avec une autre grille.');
			return;
		}

		this.showNewGrilleForm = false;
		this.getGrilles();
	}

	async deleteGrille(grille) {
		const _this = this;
		const modalInstance = _this.ModalService.confirm({
			modalTitle: _this.$translate.instant('GRILLES.DELETE.TITLE', { code: grille.code }),
			modalMsg: _this.$translate.instant(grille.grilleParenteId != null ? 'GRILLES.DELETE.MESSAGE_LINKED' : 'GRILLES.DELETE.MESSAGE'),
			headerClass: 'modal-danger'
		});

		modalInstance.result.then(async function () {
			try {
				if (_this.selectedSens == 'stock') {
					await _this.TarifsService.deleteGrilleStock(grille.id);
				} else {
					await _this.TarifsService.deleteGrille(grille.id);
				}
			} catch (err) {
				if (err.data) {
					_this.notification.error(err.data);
				} else {
					throw err;
				}
			}

			_this.getGrilles();
		});
	}

	async exporter(modeImpression, typePrix) {
		const dateAchat = this.dateSimulationAchat;
		const filtreStatut = typePrix == 0 ? this.filtreStatutEnrobe : this.filtreStatutLiant;
		try {
			let fileName;
			this.startLoading();
			if (typePrix == 0) {
				fileName = 'Simulation_de_prix_enrobés';
			} else {
				fileName = 'Simulation_de_prix_liants';
			}
			let resultat = undefined;
			try {
				resultat = await this.TarifsService.exportEnrobes(modeImpression, this.selectedGrille.id, dateAchat, typePrix, filtreStatut);
			} catch (ex) {
				//si on a des exception à afficher, le faire de cette manière à cause du format de retour de type fichier
				const msgException = String.fromCharCode.apply(null, new Uint8Array(ex.data));
				this.notification.error('CHANTIERS.' + msgException);
				return false;
			}
			if (resultat) {
				const data = resultat.data;
				let headers = resultat.headers;
				headers = headers();

				const contentType = headers['content-type'];

				const linkElement = document.createElement('a');
				try {
					const blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
					const url = window.URL.createObjectURL(blob);
					linkElement.setAttribute('href', url);
					if (modeImpression == 0) {
						linkElement.setAttribute('download', fileName + '.pdf');
					} else {
						linkElement.setAttribute('download', fileName + '.xlsx');
					}

					const clickEvent = new MouseEvent('click', {
						view: window,
						bubbles: true,
						cancelable: false
					});
					linkElement.dispatchEvent(clickEvent);
				} catch (ex) {
					//console.log(ex);
				}
				return true;
			}
		} catch (ex) {
			this.notification.error(ex.data);
			return false;
		} finally {
			this.stopLoading();
		}
	}

	async getTvaListe() {
		try {
			this.tvaListe = await this.TarifsService.getTvaListe();
		} catch (err) {
			if (err.data) {
				this.notification.error(err.data);
			} else {
				throw err;
			}
		}
	}
	async getTypesPrix() {
		if (!this.prixTypes) {
			try {
				this.prixTypes = await this.TarifsService.getTypesPrix();
			} catch (err) {
				if (err.data) {
					this.notification.error(err.data);
				} else {
					throw err;
				}
			}
		}
	}

	async exporterGrilleExcel(grille, tableState) {
		try {
			this.startLoading();
			var fileName = grille.libelle;
			let resultat = undefined;
			try {
				var that = this;
				let previousTableState;

				if (tableState) {
					previousTableState = tableState;
				}
				const filters = that.PaginationService.getFilters(previousTableState);
				const sorts = that.PaginationService.getSorts(previousTableState);
				const pagination = that.PaginationService.getPagination(previousTableState);

				resultat = await this.TarifsService.exportGrille(grille.id, filters, sorts, pagination);
			} catch (ex) {
				//si on a des exception à afficher, le faire de cette manière à cause du format de retour de type fichier
				var msgException = String.fromCharCode.apply(null, new Uint8Array(ex.data));
				this.notification.error('CHANTIERS.' + msgException);
				return false;
			}
			if (resultat) {
				let data = resultat.data;
				let headers = resultat.headers;
				headers = headers();

				var contentType = headers['content-type'];

				var linkElement = document.createElement('a');
				try {
					var blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
					var url = window.URL.createObjectURL(blob);
					linkElement.setAttribute('href', url);
					linkElement.setAttribute('download', fileName + '.xlsx');

					var clickEvent = new MouseEvent('click', {
						view: window,
						bubbles: true,
						cancelable: false
					});
					linkElement.dispatchEvent(clickEvent);
				} catch (ex) {
					console.log(ex);
				}
				return true;
			}
		} catch (ex) {
			this.notification.error(ex.data);
			return false;
		} finally {
			this.stopLoading();
		}
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}
	async loadAllGrilles() {
		try {
			this.startLoading();
			this.allGrilles = await this.TarifsService.getAllGrilles();
		} catch (err) {
			if (err.data) {
				this.notification.error(err.data);
			} else {
				throw err;
			}
		} finally {
			this.stopLoading();
		}
	}

	selectedPrixCoche(priceGridName) {
		let grid = priceGridName == 'prixProduits' ? this.displayedGrille.lignes : this.displayedGrille[priceGridName];

		this.isAllPrixCocheSelected = grid.every((x) => x.isSelectedCoche);
		this.isAnyPrixCocheSelected = grid.some((x) => x.isSelectedCoche);
		this.getCocheElementCount(grid);
	}

	selectAllPrixCoche(priceGridName) {
		let grid = priceGridName == 'prixProduits' ? this.displayedGrille.lignes : this.displayedGrille[priceGridName];
		angular.forEach(
			grid,
			function (prix) {
				prix.isSelectedCoche = this.isAllPrixCocheSelected;
			},
			this
		);

		this.isAnyPrixCocheSelected = grid.some((x) => x.isSelectedCoche);
		this.getCocheElementCount(grid);
	}

	async saveAllPrixCocheSelected(priceGridName) {
		let grid = priceGridName == 'prixProduits' ? this.displayedGrille.lignes : this.displayedGrille[priceGridName];
		const selectedPrixListCoche = grid.filter((prix) => prix.isSelectedCoche && prix.isChanging);

		if (selectedPrixListCoche.length == 0) {
			this.notification.error(this.$translate.instant('GRILLES.NOTHING_TO_SAVE'));
			return;
		}

		try {
			for (const prix of selectedPrixListCoche) {
				await this.addPrix(prix);
			}
			this.resetAllPrixcoche(priceGridName);
			this.notification.success(this.$translate.instant('GRILLES.SUCCESS_SAVE'));
		} catch (error) {
			console.log(error);
		}
	}

	async deleteAllPrixCocheSelected(priceGridName) {
		let grid = priceGridName == 'prixProduits' ? this.displayedGrille.lignes : this.displayedGrille[priceGridName];
		const selectedPrixListCoche = grid.filter((prix) => prix.isSelectedCoche && prix.id);
		if (selectedPrixListCoche.length == 0) {
			this.notification.error(this.$translate.instant('GRILLES.NOTHING_TO_DELETE'));
			return;
		}

		const modalInstance = await this.deleteAllPrixCocheModal();
		modalInstance.result
			.then(async () => {
				try {
					if (priceGridName == 'prixProduits') {
						for (const prix of selectedPrixListCoche) {
							await this.deletePrix(prix);
						}
					} else {
						const ids = [];
						angular.forEach(
							selectedPrixListCoche,
							function (prix) {
								if (prix.type) {
									ids.push(prix.id);
									prix.type = 1;
									prix.prixAchat = null;
									prix.transporte = null;
									prix.id = 0;
									prix.valeur = null;
									prix.dateModification = null;
								}
							},
							this
						);
						await this.TarifsService.deletePrix(ids);
					}
					this.notification.success(this.$translate.instant('GRILLES.SUCCESS_DELETE'));
				} catch (error) {
					this.notification.error(error.data);
				}
			})
			.finally(() => {
				this.resetAllPrixcoche(priceGridName);
			});
	}

	resetAllPrixcoche(priceGridName = null) {
		let grid = [];
		if (priceGridName) {
			grid = priceGridName == 'prixProduits' ? this.displayedGrille.lignes : this.displayedGrille[priceGridName];
		}

		if (grid.length > 0) {
			grid.forEach((prix) => {
				prix.isSelectedCoche = false;
			});
		}

		this.isAllPrixCocheSelected = false;
		this.isAnyPrixCocheSelected = false;
		this.CocheSelectedElementCount = 0;
	}

	async deleteAllPrixCocheModal() {
		return this.ModalService.confirm({
			modalTitle: this.$translate.instant('GRILLES.DELETE_ALL_PRICE_CHECK.TITLE'),
			modalMsg: this.$translate.instant('GRILLES.DELETE_ALL_PRICE_CHECK.MESSAGE'),
			headerClass: 'modal-danger'
		});
	}

	getCocheElementCount(grid) {
		this.CocheSelectedElementCount = grid.filter((x) => x.isSelectedCoche).length;
	}

	isValueLineEmpty(lignePrix) {
		return (
			lignePrix?.valeur === null ||
			lignePrix?.valeur === undefined ||
			(isNaN(Number(lignePrix?.valeur)) && lignePrix?.valeur !== 0) ||
			lignePrix?.valeur === ''
		);
	}

	changeValuePrix(lignePrix) {
		lignePrix.valueEmpty = this.isValueLineEmpty(lignePrix);
	}

	async freezPrice(prices, priceGridName = []) {
		if (prices.some((prix) => prix.isChanging)) {
			this.notification.error(this.$translate.instant('GRILLES.INFOBULLE.FREEZPRICE_SAVE_BEFORE'));
			return;
		}

		if (prices.length == 0) {
			this.notification.error(this.$translate.instant('GRILLES.NOTHING_TO_FREEZE'));
			return;
		}

		const toggleFreeze = (prix) => {
			if (!prix.isFrozen) {
				prix.originalValeur = prix.valeur;
				prix.originalType = prix.type;
				prix.valeur = prix.prix.toFixed(2);
				prix.type = 1;
			} else {
				prix.valeur = prix.originalValeur;
				prix.type = prix.originalType;
				prix.originalValeur = null;
				prix.originalType = null;
			}
			prix.isFrozen = !prix.isFrozen;
		};

		const rollbackFreeze = (prix) => {
			if (prix.isFrozen) {
				prix.valeur = prix.originalValeur;
				prix.type = prix.originalType;
				prix.originalValeur = null;
				prix.originalType = null;
			} else {
				prix.originalValeur = prix.valeur;
				prix.originalType = prix.type;
				prix.valeur = prix.prix?.toFixed(2);
				prix.type = 1;
			}
			prix.isFrozen = !prix.isFrozen;
		};

		try {
			prices.forEach(toggleFreeze);
			await this.TarifsService.freezPrice(prices);
			this.notification.success(this.$translate.instant('GRILLES.SUCCESS_FREEZE'));

			if (priceGridName.length > 0) {
				this.resetAllPrixcoche(priceGridName);
			}
		} catch (error) {
			console.log(error);
			this.notification.error(error.data);
			prices.forEach(rollbackFreeze);
		}
	}

	sectionHasErrors(section, displayedGrille) {
		const map = {
			granulats: () => displayedGrille?.prixGranulats?.some((p) => p.hasMissingPrix) ?? this.selectedGrille?.hasMissingGranulats,
			enrobes: () =>
				displayedGrille?.prixEnrobes?.some((p) => p.hasMissingPrix || p.hasMissingComposantPrix) ?? this.selectedGrille?.hasMissingEnrobes,
			liants: () =>
				displayedGrille?.prixLiants?.some((p) => p.hasMissingPrix || p.hasMissingComposantPrix) ?? this.selectedGrille?.hasMissingLiants,
			prestations: () => displayedGrille?.prixPrestations?.some((p) => p.hasMissingPrix) ?? this.selectedGrille?.hasMissingPrestations,
			transports: () => displayedGrille?.prixTransports?.some((p) => p.hasMissingPrix) ?? this.selectedGrille?.hasMissingTransports,
			produits: () => displayedGrille?.lignes?.some((p) => p.hasMissingPrix) ?? this.selectedGrille?.hasMissingProduits
		};
		return map[section]?.() ?? false;
	}

	async freezAllPrice(priceGridName) {
		let grid = priceGridName == 'prixProduits' ? this.displayedGrille.lignes : this.displayedGrille[priceGridName];
		const priceToFreeze = grid.filter(
			(prix) => [2, 3, 4, 5].includes(prix.type) && !prix.isFrozen && prix.isSelectedCoche && prix.prix != null && prix.valeur != null
		);
		await this.freezPrice(priceToFreeze, priceGridName);
	}
}
